export enum EErrorStatus {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  UnprocessableEntity = 422,
  InternalServerError = 500,
}

export enum EOrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum EOrderDirectionShort {
  ASC = 'ASC',
  DESC = 'DESC',
}
